const CLIENT_ID_STORAGE_KEY = "craftcivil-client-id";

function generateClientId(): string {
  if (typeof crypto !== "undefined" && typeof crypto.randomUUID === "function") {
    return crypto.randomUUID();
  }

  return `client-${Date.now()}-${Math.random().toString(36).slice(2, 10)}`;
}

export function getClientId(): string {
  if (typeof window === "undefined") {
    return "server-render";
  }

  const existing = window.localStorage.getItem(CLIENT_ID_STORAGE_KEY);
  if (existing && existing.trim()) {
    return existing;
  }

  const created = generateClientId();
  window.localStorage.setItem(CLIENT_ID_STORAGE_KEY, created);
  return created;
}
